module.exports = __webpack_public_path__ + "img/title-bg.8509ad84.png";